import { render, staticRenderFns } from "./textcontent.vue?vue&type=template&id=82179600&"
import script from "./textcontent.vue?vue&type=script&lang=js&"
export * from "./textcontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports